window.$ = window.jQuery = require('jquery');

const React = global.React = require('react');
const ReactDOM = global.ReactDOM = require('react-dom');
const ReactBootstrap = global.ReactBootstrap = require('react-bootstrap');
const MUICSS = global.MUICSS = require('muicss/react');
const MaterialUI = global.MaterialUI = require('material-ui');
const UA = global.UA = require('ua-parser-js');

let BOOKLIST = global.BOOKLIST = require('../../assets/javascripts/BOOKLIST.js.es6').BOOKLIST;
require('../../assets/javascripts/components/common');